import { Link } from "react-router-dom"

import { cn } from "@/lib/utils"

import { HuLogoSmall } from "./HuLogoSmall"

export function KitchenBrandLink({
  compact = false,
  size = "nav",
}: {
  compact?: boolean
  size?: "auth" | "nav"
}) {
  const isAuth = size === "auth"

  return (
    <Link
      aria-label="HO Kitchen"
      className={cn(
        "flex no-underline",
        isAuth ? "flex-col items-start gap-3" : "items-center gap-2.5",
      )}
      to="/kitchen/today"
    >
      <HuLogoSmall className={isAuth ? "size-12" : "size-7"} />
      <span className={cn("flex min-w-0", isAuth ? "flex-col gap-0.5" : "items-baseline gap-2")}>
        <span
          className={cn(
            "font-semibold tracking-tight text-foreground",
            isAuth ? "text-lg" : "text-sm",
          )}
        >
          HO Kitchen
        </span>
        {compact ? null : (
          <span
            className={cn(
              "tracking-[0.18em] text-muted-foreground uppercase",
              isAuth ? "text-[10px]" : "hidden text-[10px] sm:inline",
            )}
          >
            Haute Organic
          </span>
        )}
      </span>
    </Link>
  )
}
